import { Component, computed, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeSelectSingleComponent } from '../../forms/employee-select-single/employee-select-single.component';
import { DashboardService } from '../../../../_services/dashboard-api-service/dashboard.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { LoaderComponent } from '../../loader/loader.component';
import { NoCardsAvailableDisplayComponent } from '../../cards/no-cards-available-display/no-cards-available-display.component';

@Component({
  selector: 'app-issue-card-select-employee-modal',
  imports: [EmployeeSelectSingleComponent, LoaderComponent, NoCardsAvailableDisplayComponent],
  templateUrl: './issue-card-select-employee-modal.component.html',
})
export class IssueCardSelectEmployeeModalComponent {
  readonly ngbActiveModal = inject(NgbActiveModal);
  readonly dashboardService = inject(DashboardService);

  selectedEmployeeId: string = '';
  availableCards = toSignal(this.dashboardService.getAvailableCardCount(), { initialValue: null });
  checkingCards = computed(() => this.dashboardService.isCheckingCardAvailability());
  hasAvailableCards = computed(() => (this.availableCards() ?? 0) > 0);

  public onCancel(): void {
    this.ngbActiveModal.dismiss();
  }

  getSelectedEmployee($event: string | null) {
    if ($event) {
      this.selectedEmployeeId = $event;
    }
  }

  public onAccept(): void {
    this.ngbActiveModal.close(this.selectedEmployeeId);
  }

  protected readonly Boolean = Boolean;
}
